import React from 'react';
import Utils from './Utils.js';
import FieldPlayer from './FieldPlayer.js';

class Field extends React.Component
{
	
	constructor (props)
	{
		super(props);
		
		this.image_url = require("./fondMPG"+props.nbPlayers+".png");
		
		this.playerPositions = {
			8 :[
				{x:194,y:36},
				{x:62,y:200},
				{x:194,y:135},
				{x:325,y:200},
				{x:62,y:320},
				{x:194,y:390},
				{x:325,y:320},
				{x:194,y:490}
			],
			10 :[
				{x:194,y:36},
				{x:62,y:205},
				{x:125,y:125},
				{x:251,y:125},
				{x:325,y:205},
				{x:62,y:315},
				{x:125,y:410},
				{x:251,y:410},
				{x:325,y:315},
				{x:194,y:490}
			]
		};
	}
	
	render()
	{
		return (
			<div className="field">
				{Utils.range(1,this.props.nbPlayers).map(playerNum => 
					<FieldPlayer key={"fielPlayer"+playerNum} playerNum={playerNum} playerTeam={(playerNum>this.props.nbPlayers/2 ? 1 : 0)} playerName={this.props.playerNames[playerNum-1]} playerPosition={this.playerPositions[this.props.nbPlayers][playerNum-1]} onPlayerSwitch={this.props.onPlayerSwitch}/>
				)}
			</div>
		);
	}
}

export default Field;
